/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'
import 'react-multiple-select-dropdown-lite/dist/index.css'
import {
  BrowserRouter as Router, Link, NavLink, Route, Switch
} from 'react-router-dom'
import bcsFetch from './components/Childs/bcsFetch'
import ImportData from './pages/ImportData'
import LogTable from './pages/LogTable'
import ZohoInventory from './pages/ZohoInventory'
import logo from './resources/icons/logo.svg'
import boostedCRMLogo from './resources/img/boosted_crm_logo.png'
import './resources/sass/app.scss'

function App() {
  const [isAuthorized, setisAuthorized] = useState(false)
  const [wcStatus, setWcStatus] = useState({})
  const [checkingPrevInteg, setCheckingPrevInteg] = useState(false)
  const [wcInventoryConf, setWcInventoryConf] = useState({
    name: 'Zoho Inventory API',
    enabled: true,
    clientId: '',
    clientSecret: '',
    orgId: '',

    field_map: {
      inventoryCustomerFields: [{ formField: '', zohoFormField: '' }],
      inventorySalesFields: [{ formField: '', zohoFormField: '' }]
    },
    newInteg: true,
    enableAuthorizationPage: false,
    actions: {
      inventoryCustomer: {},
      inventorySales: {
        warehouseId: '',
      }
    }
  })
  useEffect(() => {
    setCheckingPrevInteg(true)
    bcsFetch({}, 'bc_get_integration_data')
      .then(result => {
        let integDetails = JSON.parse(JSON.stringify(wcInventoryConf))
        if (result?.success) {
          if (result.data.integ.length) {
            integDetails = JSON.parse(result.data.integ[0].integration_details)
            setWcInventoryConf(integDetails)
            setisAuthorized(true)
          }
          if (result.data.wc_status) setWcStatus(result.data.wc_status)
        }
        setCheckingPrevInteg(false)
      })
  }, [])

console.log(checkingPrevInteg)
  return (
    <Router basename={typeof bc_inventory_connector !== 'undefined' ? bc_inventory_connector.baseURL : '/'}>
      <div id="btcd-app">

        <>
          <div className="nav-wrp">
            <div className="flx">
              <div className="logo flx" title="WooCommerce Zoho Inventory">

                <Link to="/" className="flx">
                  <img src={logo} alt="logo" className="ml-2" />
                  <span className="ml-2">Home</span>
                </Link>
              </div>
              <nav className="top-nav ml-2">
                <NavLink
                  to="/import-data"
                  activeClassName="app-link-active"
                >
                  Import to Zoho
                </NavLink>
                <NavLink
                  to="/log-table"
                  activeClassName="app-link-active"
                >
                  All Logs
                </NavLink>
              </nav>
              {/* <div className="pro-link">
                <a href='https://www.bitapps.pro/'>Get Pro</a>
              </div> */}
              <div className="author-link">
                <a href='https://boostedcrm.com/' target='_blank' rel="noreferrer">Powerd By
                  <img src={boostedCRMLogo} alt='logo not found'></img>
                </a>
              </div>
            </div>
          </div>
          <Switch>
            <Route exact path="/">
                <ZohoInventory
                  isAuthorized={isAuthorized}
                  setisAuthorized={setisAuthorized}
                  wcInventoryConf={wcInventoryConf}
                  setWcInventoryConf={setWcInventoryConf}
                  checkingPrevInteg={checkingPrevInteg}
                />
          
            </Route>
            <Route path="/import-data">
              <ImportData
                wcStatus={wcStatus}
              />
            </Route>
            <Route path="/log-table">
              <LogTable />
            </Route>
          </Switch>
        </>




      </div>
    </Router >
  )
}

export default App
